import { Injectable } from '@angular/core';
import { Business } from '@models/businesses';
import {
	Matter,
	PersonMatterClient,
	BusinessMatterClient,
} from '@models/matter';
import { AllAdjustmentsCalculated } from '@state/matter/adjustments/adjustments.selectors';
import { cloneDeep } from 'lodash';
import { BaseFormMapper } from '../../base-form-mapper';
import { NameFormattingSettings } from '@models/businessSettings/settings';

@Injectable({
	providedIn: 'root',
})
export class RBC_COLLATERAL_SCHEDULE_FIXED_RATE_Mapper extends BaseFormMapper<RBC_COLLATERAL_SCHEDULE_FIXED_RATE> {
	CloserToFormMappings = Mappings;

	mergeFormData(
		formData: RBC_COLLATERAL_SCHEDULE_FIXED_RATE,
		matter: Matter,
		nameFormattingSettings: NameFormattingSettings,
		sellers: (PersonMatterClient | BusinessMatterClient)[],
		buyers: (PersonMatterClient | BusinessMatterClient)[],
		adjustments: AllAdjustmentsCalculated,
		business: Business,
	) {
		const _formData = formData
			? cloneDeep(formData)
			: ({} as RBC_COLLATERAL_SCHEDULE_FIXED_RATE);

		return _formData;
	}

	MapValues(): Partial<RBC_COLLATERAL_SCHEDULE_FIXED_RATE> {
		return {};
	}
}

const Mappings: RBC_COLLATERAL_SCHEDULE_FIXED_RATE = {
	interestRate: 'rate',
	principalAmount: 'amount',
	clientsNames: 'clientName',
};

export interface RBC_COLLATERAL_SCHEDULE_FIXED_RATE {
	clientsNames: string;
	principalAmount: string;
	interestRate: string;
	// lenderReferenceNumber: string,
	// date: string,
	// mortgagors:string,
	// guarantors:string,

	// propertyCity: string,
	// // propertyProvince: string,
	// // propertyPostalCode: string,

	// mortgageAmount:string,
	// mortgageRegistrationNumber:string,
	// mortgageRegistrationDate:string,
	// taxesPaidInFullDate:string,
	// taxesPropertyCode:string,
	// titleOpinion:string,
	// titleInsuranceReferenceNumber:string,
	// titleInsurerName:string,
	// lawyerName:string,
	// exceptions:string,

	// bankTitle:string,
	// reportType:string,

	// checkDocument:string,
	// checkPolicy:string,
	// checkProtocol:string
}
